const KEYWORD_GENERATOR_TOOL_SET_FOCUSED_KEYWORD_LIST =
  "KEYWORD_GENERATOR_TOOL_SET_FOCUSED_KEYWORD_LIST";

export default { KEYWORD_GENERATOR_TOOL_SET_FOCUSED_KEYWORD_LIST };
